module.exports = {
  'Stat':'Stat',
  'PRN':'PRN',
  'x1':'x1',
  'x2':'x2',
  'x3':'x3',
  'x4':'x4',
  'MD':'MD',
  'MN':'MN'
};
